// extracted by mini-css-extract-plugin
module.exports = {"dismissed":"SharedNotificationsWidget_dismissed__1NheQ","dismissalCell":"SharedNotificationsWidget_dismissalCell__3tVty"};